export default __webpack_public_path__ + "static/media/evapotranspiration-active.c2ddf66b.svg";